<!--
    Summary:
        科研技术
    ChangeLog:
        Labbor on 2020/2/21 added
-->
<template>
  <div class="v-technology">
    <banner>
      <img src="../../assets/images/about/Header_1920x380_technology.jpg"/>
      <div slot="title">{{$t('Technology.Title')}}</div>
    </banner>

    <!-- 我们深明检测准确的重要性 -->
    <card class="team">
      <div slot="title">{{$t('Technology.P1Title')}}</div>
      <p class="detail2">{{$t('Technology.P1Detail')}}</p>
    </card>

    <!-- 团队 -->
    <div class="team-list">
      <hover-box class="team-item" background="rgba(54,141,167,0.9)" show-shader>
        <img src="../../assets/images/about/scientist.jpg"/>
        <div class="main-text">
          {{$t('Technology.P2_1Title')}}
        </div>
        <div slot="hover">{{$t('Technology.P2_1Detail')}}</div>
      </hover-box>
      <hover-box class="team-item" background="rgba(54,141,167,0.9)" show-shader>
        <img src="../../assets/images/about/mlt.jpg"/>
        <div class="main-text">
          {{$t('Technology.P2_2Title')}}
        </div>
        <div slot="hover">{{$t('Technology.P2_2Detail')}}</div>
      </hover-box>
      <hover-box class="team-item" background="rgba(54,141,167,0.9)" show-shader>
        <img src="../../assets/images/about/doctor.jpeg"/>
        <div class="main-text">
          {{$t('Technology.P2_3Title')}}
        </div>
        <div slot="hover">{{$t('Technology.P2_3Detail')}}</div>
      </hover-box>
    </div>

    <div class="huge-banner">
      <hover-box class="banner" background="transparent">
        <div class="shader" style="background-color: rgba(0,0,0,0.5)"></div>
        <img src="../../assets/images/about/technology.jpg"/>
        <div class="main-text">
          <span class="text">{{$t('Technology.P3Title')}}</span>
        </div>
        <div slot="hover"><span class="text">{{$t('Technology.P3Detail')}}</span></div>
      </hover-box>
    </div>

    <card class="collaboration">
      <div slot="title">{{$t('Technology.P4Title')}}</div>

      <div class="labs">
        <hover-box class="lab" background="rgba(54,141,167,0.9)">
          <img src="../../assets/images/about/mayoclinic.png"/>
          <div slot="hover">
            {{$t('Technology.P4_1Detail')}}
            <div>
              <img src="../../assets/images/about/United-States.png" height="32" width="32"/>
            </div>
          </div>
        </hover-box>
        <hover-box class="lab" background="rgba(54,141,167,0.9)">
          <img src="../../assets/images/about/natera.png"/>
          <div slot="hover">
            {{$t('Technology.P4_2Detail')}}
            <div>
              <img src="../../assets/images/about/United-States.png" height="32" width="32"/>
            </div>
          </div>
        </hover-box>
        <hover-box class="lab" background="rgba(54,141,167,0.9)">
          <img src="../../assets/images/about/Lab-partner_Logo_V0.1-02.png"/>
          <div slot="hover">
            {{$t('Technology.P4_3Detail')}}
            <div>
              <img src="../../assets/images/about/Singapore.png" height="32" width="32"/>
            </div>
          </div>
        </hover-box>
      </div>
    </card>
  </div>
</template>

<script>
  import banner from '@/components/banner'
  import card from '@/components/card'
  import hoverBox from '@/components/hover-box'

  export default {
    components: {
      banner,
      card,
      hoverBox
    },
    data() {
      return {}
    },
    methods: {},
  }
</script>

<style scoped lang="scss">
  .v-technology {

    .team-list {
      display: flex;

      .team-item {
        flex-grow: 1;
      }
      .team-item:hover {
        .main-text {
          opacity: 0;
        }
      }
    }
    .huge-banner {
      background-color: #e9faff;
      padding-top: 60px;
      padding-bottom: 60px;

      .banner {
        width: 1200px;
        margin: 0 auto;
      }

      .shader {
        z-index: 1;
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
      }

      .banner .text {
        font-size: 28px !important;
        font-weight: 700 !important;
      }

      .banner:hover {
        .main-text {
          opacity: 0;
        }
      }
    }


    .labs{
      display: flex;
      margin-right: -20px;
      margin-bottom: 40px;
      .lab {
        flex-grow: 1;
        margin-right: 20px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/about/technology.vue